export const ImageConfig: any = {
  maxFileSize: 3145728,
  serviceUrl: 'property/uploadPropertyImage'
};
